import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export const initGA = () => {
  // Initialization is now handled by the script tag in index.html
};

export const GAPageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-SBG1YX0JPJ', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};
